var _circle, _rect, _line, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuzzer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 7.5,
    r: 3.75,
    fill: "none",
    stroke: "#00A2C7",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 23.4,
    height: 27.4,
    rx: 3.2,
    fill: "none",
    stroke: "#00A2C7",
    strokeWidth: 1.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14.2,
    x2: 24,
    y2: 14.2,
    stroke: "#00A2C7",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6875 22.125H17.3125C17.4948 22.125 17.6697 22.0526 17.7986 21.9236C17.9276 21.7947 18 21.6198 18 21.4375C18 21.2552 17.9276 21.0803 17.7986 20.9514C17.6697 20.8224 17.4948 20.75 17.3125 20.75H7.6875C7.50516 20.75 7.33029 20.8224 7.20136 20.9514C7.07243 21.0803 7 21.2552 7 21.4375C7 21.6198 7.07243 21.7947 7.20136 21.9236C7.33029 22.0526 7.50516 22.125 7.6875 22.125Z",
    fill: "#00A2C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6875 24.875H17.3125C17.4948 24.875 17.6697 24.8026 17.7986 24.6736C17.9276 24.5447 18 24.3698 18 24.1875C18 24.0052 17.9276 23.8303 17.7986 23.7014C17.6697 23.5724 17.4948 23.5 17.3125 23.5H7.6875C7.50516 23.5 7.33029 23.5724 7.20136 23.7014C7.07243 23.8303 7 24.0052 7 24.1875C7 24.3698 7.07243 24.5447 7.20136 24.6736C7.33029 24.8026 7.50516 24.875 7.6875 24.875Z",
    fill: "#00A2C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6875 19.375H17.3125C17.4948 19.375 17.6697 19.3026 17.7986 19.1736C17.9276 19.0447 18 18.8698 18 18.6875C18 18.5052 17.9276 18.3303 17.7986 18.2014C17.6697 18.0724 17.4948 18 17.3125 18H7.6875C7.50516 18 7.33029 18.0724 7.20136 18.2014C7.07243 18.3303 7 18.5052 7 18.6875C7 18.8698 7.07243 19.0447 7.20136 19.1736C7.33029 19.3026 7.50516 19.375 7.6875 19.375Z",
    fill: "#00A2C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuzzer);
export default __webpack_public_path__ + "static/media/buzzer.4612f611095aa901d4e8ab87ced316aa.svg";
export { ForwardRef as ReactComponent };